export const getNameFromSignatureProperties = (properties) => {
    let commonName = "";
    let organizationName = "";
    for (const [key, value] of properties) {
        if (key === "commonName") {
            commonName = value;
        }
        if (key === "organizationName") {
            organizationName = value;
        }
    }
    if (!commonName && !organizationName) {
        return "Unknown";
    }
    return commonName ? commonName : organizationName;
};
//# sourceMappingURL=signatures.js.map